<template>
  <div style="padding: 20px">
    <el-form ref="form" :model="form" label-width="120px" style="width: 45%" v-if="type == 2 && status==1">
      <span v-permission="'alreadyAssigned:edit'">
        <el-button type="primary" style="margin:20px;" @click="$refs.driver.show(tabName,checkList,id)" >修改分配司机</el-button>
      </span>
    </el-form>
    <el-form ref="form" :model="form" label-width="120px" style="width: 45%" v-if="type == 2 && status==2">
      <span v-permission="'alreadyAssignedConfirmed:edit'">
        <el-button type="primary" style="margin:20px;" @click="$refs.driver.show(tabName,checkList,id)" >修改分配司机</el-button>
      </span>
    </el-form>
    <div>
      <el-tabs v-model="tabName" @tab-click="tabClick">
        <el-tab-pane label="已发货" name="2"></el-tab-pane>
        <el-tab-pane label="待发货" name="3" v-if="lastRecheck==true"></el-tab-pane>
      </el-tabs>
    </div>
    <el-row v-if="tabName == 2">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        :header-cell-style="tableHeaderCenter"
        :cell-style="tableCenter"
        size="small"
        @selection-change="checkSelectionChange"
      >
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="orderOutboundCollectId" label="发货单号"/>
        <el-table-column prop="district" label="区县" />
        <el-table-column prop="town" label="街道、镇" />
        <el-table-column prop="address" label="收货地址" />
        <el-table-column prop="receiver" label="收货人" />
        <el-table-column prop="receiverPhone" label="收货人号码" />
        <el-table-column prop="driverName" label="派送司机" />
        <el-table-column prop="warehouseName" label="发货仓" />
        <el-table-column prop="pieceNum" label="发货件数"/>
        <el-table-column prop="fruitProductNum" label="水果重量(kg)" width="150"/>
        <el-table-column prop="bigSize" label="大(件)" />
        <el-table-column prop="mediumSize" label="中(件)" />
        <el-table-column prop="smallSize" label="小(件)" />  
      </el-table>
      <div style="font-size: 13px;color: #606266;position: absolute;right:0px; ">
          每页显示记录数:
        <el-select v-model="limit" @change="handlePageSizeChange" style="width:80px;height: 15px !important;">
          <el-option  value="10">10 条/页</el-option >
          <el-option  value="20">20 条/页</el-option >
          <el-option  value="50">50 条/页</el-option >
          <el-option  value="100">100 条/页</el-option >
        </el-select>
      </div>
      <Pagination
        :total="pageData.totalRecords"
        :page.sync="pageData.currentPage"
        :limit.sync="pageData.pageSize"
        @pagination="paginationChange"
      />
    </el-row>
    <el-row v-if="tabName == 3">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        :header-cell-style="tableHeaderCenter"
        :cell-style="tableCenter"
        size="small"
        @selection-change="checkSelectionChange"
      >
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="district" label="区县" />
        <el-table-column prop="town" label="街道、镇" />
        <el-table-column prop="address" label="收货地址" />
        <el-table-column prop="receiver" label="收货人" />
        <el-table-column prop="receiverPhone" label="收货人号码" />
        <el-table-column prop="driverName" label="派送司机" />
        <el-table-column prop="unOutboundNum" label="待发货数"  />
        <el-table-column prop="fruitProductNum" label="水果重量(kg)" width="150"/>
        <el-table-column prop="bigSize" label="大(件)" />
        <el-table-column prop="mediumSize" label="中(件)" />
        <el-table-column prop="smallSize" label="小(件)" />  
      </el-table>
      <div style="font-size: 13px;color: #606266;position: absolute;right:0px; ">
          每页显示记录数:
        <el-select v-model="limit" @change="unOutHandlePageSizeChange" style="width:80px;height: 15px !important;">
          <el-option  value="10">10 条/页</el-option >
          <el-option  value="20">20 条/页</el-option >
          <el-option  value="50">50 条/页</el-option >
          <el-option  value="100">100 条/页</el-option >
        </el-select>
      </div>
      <Pagination
        :total="pageData.totalRecords"
        :page.sync="pageData.currentPage"
        :limit.sync="pageData.pageSize"
        @pagination="paginationChange"
      />
    </el-row>
    <div style="margin:40px 0 0 40px" >
      <el-button @click="closePage">返 回</el-button>
    </div>
    <distributionQuickDialog :showDialog="false" ref="driver" @closeDialog="closeDialog"></distributionQuickDialog>
  </div>

</template>

<script>
import Pagination from "@/components/Pagination";
import distributionQuickDialog from "./modules/distributionQuickDialog";
import {
  detailList,
  unOutboundDetailList
} from "@/api/logistics";
import { data } from "vue-barcode";
export default {
  name: "alreadyAssignedDetail",
  components: { Pagination,distributionQuickDialog },
  data(){
    return{
      form:{
      },
      pageData: {
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0
      },
      tableData:[],   //列表
      id:'',
      driverId:'',//司机id
      type:'',//类型 1 详情，2修改
      route:{},
      checkList:[],//选中需要修改司机的数据
      limit:10,
      status:'',//1.待确认 2.已确认
      showDialog: false,
      tabName: "2",//2.已发货 3.未发货
      lastRecheck:true//是否显示待发货
    }
  },
  computed:{
  },
  created() {
    this.tableData = [];
    this.id = this.$route.query.id;
    this.driverId = this.$route.query.driverId;
    this.type = this.$route.query.type;
    this.tabName = "2";
    if (this.id != undefined && this.id != null && this.id != '') {
      this.getTableData();
    }
    this.route = this.$route
  },
  deactivated(){
    this.$store.dispatch("delView", this.route);//调用store/modules/tagViews 中 delView方法
  },
  methods:{
    // 获取数据
    getTableData() {
      let data = {
        recheckId: this.id,
        currentPage: this.pageData.currentPage,
        pageSize: this.pageData.pageSize
      };

      detailList(data).then(res => {
        if (res.code == 0) {
          this.tableData = res.data;
          this.pageData = res.page;
          if(res.dataExt.status){
            this.status = res.dataExt.status;
          }
          if(res.dataExt.lastRecheck != undefined && res.dataExt.lastRecheck != null){
            this.lastRecheck = res.dataExt.lastRecheck;
          }
        }
      });
    },
  // 获取未发货数据
    getTableUnOutboundData() {
      let data = {
        driverId: this.driverId,
        currentPage: this.pageData.currentPage,
        pageSize: this.pageData.pageSize
      };

      unOutboundDetailList(data).then(res => {
        if (res.code == 0) {
          this.tableData = res.data;
          this.pageData = res.page;
          if(res.dataExt.status){
            this.status = res.dataExt.status;
          }
        }
      });
    },
    closePage(){
      this.$router.push({name:'alreadyAssigned'});
      this.$store.dispatch("delView", this.$route);
    },
    // 选中某行
    checkSelectionChange(list) {
      let checkList = [];
      if(list.length > 0){
        if(this.tabName == 2){
          list.forEach(item => {
            checkList.push(item.orderOutboundCollectId);
          })
        } else {
          list.forEach(item => {
            checkList = checkList.concat(item.orderIds);
          })
        }
        
      }  
      this.checkList = checkList;
    },
    // 分页改变
    paginationChange() {
      this.getTableData();
    },
    handlePageSizeChange(){
      this.pageData.pageSize = Number(this.limit);
      this.getTableData();
    },
    unOutHandlePageSizeChange(){
      this.pageData.pageSize = Number(this.limit);
      this.getTableUnOutboundData();
    },
    closeDialog() {
      this.showDialog = false;
      this.checkList = [];
      this.tabClick();
    },
    // 切换已发货和未发货
    tabClick() {
      this.pageData.currentPage = 1;
      if (this.tabName == 2) {
        this.checkList = [];
        this.pageData.currentPage = 1;
        this.getTableData();
      } else if (this.tabName == 3) {
        this.checkList = [];
        this.pageData.currentPage = 1;
        this.getTableUnOutboundData();
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/logisticsDelivery/alreadyAssignedDetail.vue